import { render, staticRenderFns } from "./AddrCom.vue?vue&type=template&id=cea07c06&"
import script from "./AddrCom.vue?vue&type=script&lang=ts&"
export * from "./AddrCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports